// import React, { Component } from 'react';
// import Cookies from 'universal-cookie';
// import Header from '../components/dashboardSubComponents/header'
// import SideBar from '../components/dashboardSubComponents/sideBarNav'
// // import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
// import { Loader } from 'react-overlay-loader';
// import { url } from '../components/helper'
// import RevokedDeviceViewPanel from '../components/deviceViewSubComponents/revokedDevicesViewPanal'

// class ListBranchRevokedDevices extends Component{

//     constructor(props){
//         super(props)
//         this.state = {
//             loading:true,
//             section:0,
//             devices:null,
//             branch_name:null
//         }
//         this.startStopLoader.bind(this)
//     }

//     componentWillMount = () =>{
//         var url_local = window.location.href
//         url_local = new URL(url_local);
//         var id = url_local.searchParams.get("id");
//         var branch_name = url_local.searchParams.get("tag")
//         var cookies = new Cookies();
//         var loginStatus = cookies.get('loggedIn')
//         if (loginStatus === undefined) {
//             window.location = '/login'
//         }
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         var global_ref = this
//         var http = new XMLHttpRequest()
//         http.open("GET",url+"/api/device/revoked?user_id="+user_id+"&branch_id="+id)
//         http.setRequestHeader("Authorization","Token "+token)
//         http.send()
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){
//                 var json = JSON.parse(http.responseText)
//                 if(json.status === 200){
//                     if(json.revoked_devices.length !== 0){
//                         global_ref.setState({
//                             loading:false,
//                             section:1,
//                             devices:json.revoked_devices,
//                             branch_name:branch_name
//                         })
//                     }
//                     else{
//                         global_ref.setState({
//                             loading:false,
//                             section:2,
//                         })
//                     }
//                 }
//                 else{
//                     global_ref.setState({
//                         loading:false,
//                         section:2
//                     })
//                 }
//             }
//         }
//         http.onerror = function(){
//             global_ref.setState({
//                 loading:false,
//                 section:2
//             })
//         }
//         http.ontimeout = function(){
//             global_ref.setState({
//                 loading:false,
//                 section:2
//             })
//         }
//     }

//     startStopLoader = () =>{
//         this.setState({
//             loading:this.state.loading
//         })
//     }

//     render(){
//         if(this.state.section === 0){
//             return(
//                 <div>
//                     <Loader loading={this.state.loading} fullPage={true} />
//                 </div>
//             )
//     }
//     if(this.state.section === 1){
//         return(
//             <div>
//                         <div className="clearfix" id="page-header">
//                             <div>
//                                 <Header />
//                             </div>
//                         </div>

//                         <div >
//                             <SideBar />
//                         </div>
//                         <div id="page-content-wrapper" className="rm-transition">
//                         <div id="page-content">
//                         <Loader loading={this.state.loading} fullPage={true} />
//                             <div className="row">
//                                 <div className="col-md-12">
//                                     <h1 style={{textAlign:"center"}}>{this.state.branch_name+"'s Revoked Devices"}</h1>
//                                 </div>
//                             </div>
//                             <div >
//                             {this.state.devices.map((device,i)=> <RevokedDeviceViewPanel key={i} data={device} startStopLoader={this.startStopLoader}/>)}
//                             </div>
//                         </div>
//                         </div>
//                 </div>
//         )
//     }
//     if(this.state.section === 2){
//         return(
//             <div>
//                 <div className="clearfix" id="page-header">
//                             <div>
//                                 <Header />
//                             </div>
//                         </div>

//                         <div >
//                             <SideBar />
//                         </div>
//             <div id="page-content-wrapper" className="rm-transition">
//                 <div id="page-content">
//                 <div className="row">
//             <div className="col-md-12">
//                 <h3 style={{textAlign:"center"}}>No revoked devices to show</h3>
//             </div>
//         </div>
//         </div>
//         </div>
//             </div>
//         )
//     }
// }
// }

// export default ListBranchRevokedDevices;

import React, { Component } from 'react'
import Cookies from 'universal-cookie'
import Header from '../components/dashboardSubComponents/header'
import SideBar from '../components/dashboardSubComponents/sideBarNav'
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Loader } from 'react-overlay-loader'
import { url } from '../components/helper'
import RevokedDeviceViewPanel from '../components/deviceViewSubComponents/revokedDevicesViewPanal'

const ListBranchRevokedDevices = () => {
    const [loading, setLoading] = React.useState(true)
    const [section, setSection] = React.useState(0)
    const [devices, setDevices] = React.useState([])
    const [branchName, setBranchName] = React.useState(null)

    const credentialCheck = () => {
        const url_local = new URL(window.location.href)
        const cookies = new Cookies()
        const loginStatus = cookies.get('loggedIn')

        if (!loginStatus) {
            window.location = '/login'
        }
    }
    const getRevokedDevices = async () => {
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const url_local = new URL(window.location.href)
        const branchName = url_local.searchParams.get('tag')
        const id = url_local.searchParams.get('id')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Token ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/device/revoked?user_id=${userId}&branch_id=${id}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    if (data.revoked_devices.length !== 0) {
                        setLoading(false)
                        setSection(1)
                        setDevices(data.revoked_devices)
                        setBranchName(branchName)
                    }
                    break
                default:
                    console.error('Invalid data', data)
                    setLoading(false)
                    setSection(2)
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setLoading(false)
            setSection(2)
        }
    }

    React.useEffect(() => {
        credentialCheck()
        getRevokedDevices()
    }, [])

    //PFIX: What does this do besides set itself to itself?
    const startStopLoader = () => {
        setLoading(loading)
    }

    return (
        <div>
            {section === 0 ? (
                <div>
                    <Loader loading={loading} fullPage={true} />
                </div>
            ) : (
                <div></div>
            )}
            {section === 1 ? (
                <div>
                    <div className="clearfix" id="page-header">
                        <div>
                            <Header />
                        </div>
                    </div>

                    <div>
                        <SideBar />
                    </div>
                    <div id="page-content-wrapper" className="rm-transition">
                        <div id="page-content">
                            <Loader loading={loading} fullPage={true} />
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 style={{ textAlign: 'center' }}>
                                        {branchName + "'s Revoked Devices"}
                                    </h1>
                                </div>
                            </div>
                            <div>
                                {devices.map((device, i) => (
                                    <RevokedDeviceViewPanel
                                        key={i}
                                        data={device}
                                        startStopLoader={startStopLoader}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div></div>
            )}
            {section === 2 ? (
                <div>
                    <div className="clearfix" id="page-header">
                        <div>
                            <Header />
                        </div>
                    </div>

                    <div>
                        <SideBar />
                    </div>
                    <div id="page-content-wrapper" className="rm-transition">
                        <div id="page-content">
                            <div className="row">
                                <div className="col-md-12">
                                    <h3 style={{ textAlign: 'center' }}>
                                        No revoked devices to show
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div></div>
            )}
        </div>
    )
}

export default ListBranchRevokedDevices

/**
 * Notes
 * - Require testing
 */



// WEBPACK FOOTER //
// src/Routes/ListBranchRevokedDevices.js